import React from "react";
import {
  InboxOutlined,
  FileExcelOutlined,
  CheckCircleOutlined,
  WarningOutlined,
} from "@ant-design/icons";

/**
 * A tiny looping demo of the contact import wizard: drop a file, map the
 * columns, see the results. Purely decorative CSS animation (see
 * .import-wizard-demo in index.css); prefers-reduced-motion shows a
 * static results frame instead of looping.
 */
export default function ImportWizardAnimation() {
  return (
    <div className="import-wizard-demo" aria-hidden="true">
      <div className="iwd-steps">
        <span className="iwd-step iwd-step-1">1</span>
        <span className="iwd-step-line" />
        <span className="iwd-step iwd-step-2">2</span>
        <span className="iwd-step-line" />
        <span className="iwd-step iwd-step-3">3</span>
      </div>

      <div className="iwd-body">
        <div className="iwd-stage iwd-stage-upload">
          <div className="iwd-dropzone">
            <InboxOutlined className="iwd-dropzone-icon" />
            <span className="iwd-dropzone-text">Drop your contacts file</span>
            <span className="iwd-dropzone-sub mk-mono">CSV or Excel</span>
            <span className="iwd-file-chip">
              <FileExcelOutlined /> contacts.xlsx
            </span>
          </div>
        </div>

        <div className="iwd-stage iwd-stage-map">
          <div className="iwd-map-row iwd-map-row-1">
            <span className="iwd-map-col">Column A</span>
            <span className="iwd-map-arrow">→</span>
            <span className="iwd-map-field">Name</span>
            <CheckCircleOutlined className="iwd-map-check" />
          </div>
          <div className="iwd-map-row iwd-map-row-2">
            <span className="iwd-map-col">Column B</span>
            <span className="iwd-map-arrow">→</span>
            <span className="iwd-map-field">Email</span>
            <CheckCircleOutlined className="iwd-map-check" />
          </div>
        </div>

        <div className="iwd-stage iwd-stage-result">
          <span className="iwd-result-pill iwd-result-success">
            <CheckCircleOutlined /> 2 Imported
          </span>
          <span className="iwd-result-pill iwd-result-failed">
            <WarningOutlined /> 1 Failed
          </span>
        </div>
      </div>
    </div>
  );
}
